import i18n from 'i18next';

export const columns = [
  {
    id: 'driver',
    disablePadding: false,
    label: i18n.t('Driver Name'),
    needSorting: true,
  },
  {
    id: 'driverid',
    numeric: true,
    disablePadding: false,
    label: i18n.t('roadInspection.driverId'),
    needSorting: true,
  },

  {
    id: 'date',
    numeric: true,
    disablePadding: false,
    label: i18n.t('common.date'),
    needSorting: true,
  },
  {
    id: 'report',
    numeric: true,
    disablePadding: false,
    label: i18n.t('roadInspection.defectFound'),
    needSorting: true,
  },
];
